module.exports = __webpack_public_path__ + "static/media/ZPETN.205acafe.pdf";